const applicantIdVerificationInitialState = {
    applicant: {
        name: 'Jon',
        surname: 'Doe',
        dateOfBirth: '12/12/1992',
        address: {
            city: 'London',
            postalCode: 'LF12 AA',
            street: 'Street',
        },
        idVerification: {},
    },
    scannedId: false,
    takenPhoto: false,
    photoUrl: 'http://cdn.forum.wotblitz.eu/wotb/eu//profile/13/40/72/photo-508724013-57db18ba.gif?_r=1473976512',
    verified: false,
};

export default applicantIdVerificationInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/applicantIdVerificationInitialState.js